import React, {Component} from "react";
import {connect} from "react-redux";
import {deleteShareToken, getAllAnonymousShareLinks, getListOfSharedSlidesFromToken} from "../../utils/api";
import {DataGrid} from "@mui/x-data-grid";
import {Button, CircularProgress, Grid, IconButton, List, ListItem, ListItemText, Popover, Stack} from "@mui/material";
import {copyToClipboard, isNull, notNull} from "../../utils/utils";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LinkIcon from '@mui/icons-material/Link';
import Typography from "@mui/material/Typography";
import {message} from "antd";

class SharedUrlsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: null,
            anchorElRevoke: null,
            selectedRow: null,
            urlDetailsList: {},
            sharedEntitites: null,
        }
        this.columns = null;
        this.token = '';
    }

    fetchData = () => {
        getAllAnonymousShareLinks().then((response) => {
            if (response.status === 200) {
                this.setState({
                    rows: response.data
                })
            } else {
                this.setState({
                    rows: []
                })
            }
        }).catch((error) => {
            console.log(error)
            this.setState({
                rows: []
            })
        })
    }

    componentDidMount = () => {
        this.setColumns();
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.selectedRow !== prevState.selectedRow && notNull(this.state.selectedRow)) {
            this.fetchUrlDetails();
        }
    }

    fetchUrlDetails = () => {
        // check if selectedRow id key exists in urlDetailsList
        if (notNull(this.state.urlDetailsList[this.state.selectedRow])) {
            this.setState({sharedEntitites: this.state.urlDetailsList[this.state.selectedRow]})
        } else {
            const requiredRow = this.state.rows.filter((row) => row.id === this.state.selectedRow)
            if (requiredRow.length > 0) {
                const token_id = requiredRow[0].token;

                getListOfSharedSlidesFromToken(token_id).then((response) => {
                    this.setState({
                        urlDetailsList: {
                            ...this.state.urlDetailsList,
                            [this.state.selectedRow]: response.data.slides
                        },
                        sharedEntitites: response.data.slides
                    })
                })
            }
        }
    }

    removeRowFromData = (token) => {
        this.setState({
            rows: this.state.rows.filter((row) => row.token !== token)
        })
    }

    handleTokenDelete = () => {
        this.setState({anchorElRevoke: null})
        deleteShareToken(this.token).then(res => {
            message.success('Link Removed Successfully', 2.5);
            this.removeRowFromData(this.token);
        })
    }

    getConfirmRevokeDialogComponent = () => {
        return <Popover open={this.state.anchorElRevoke} anchorEl={this.state.anchorElRevoke}
                        onClose={() => this.setState({anchorElRevoke: null})}
                        anchorOrigin={{
                            vertical: 'center', horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'center', horizontal: 'left',
                        }}>
            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} sx={{p: 1}}>
                <Typography>Invalidate Shared Link?</Typography>
                    <Button sx={{textTransform: "none"}} onClick={this.handleTokenDelete}>Yes</Button>
                    <Button sx={{textTransform: "none", color: "rgba(231,13,20,0.78)"}}
                            onClick={() => this.setState({anchorElRevoke: null})}>No</Button>
            </Stack>
        </Popover>
    }

    renderCopyUrlButton = (params) => {
        return (
            <IconButton
                variant="contained"
                color="primary"
                size="small"
                style={{marginLeft: 16}}
                onClick={(e) => {
                    e.stopPropagation();
                    copyToClipboard(params.row.url)
                }}
            >
                <LinkIcon/>
            </IconButton>
        )
    }
    renderRevokeAccessButton = (params) => {
        return (
            <IconButton
                variant="contained"
                color="primary"
                size="small"
                style={{marginLeft: 16, color: 'red'}}
                onClick={e => {
                    e.stopPropagation();
                    this.token = params.row.token;
                    this.setState({anchorElRevoke: e.currentTarget});
                }}
            >
                <DeleteForeverIcon/>
            </IconButton>
        )
    }

    getUrlDetails = () => {
        if (isNull(this.state.selectedRow)) {
            return (
                <div className={"full-parent flex-center"}>
                    <Typography variant={"h6"}>Click on any row to view shared Slides</Typography>
                </div>
            )
        } else {
            return (
                <div className={"full-parent"} style={{padding: '5px'}}>
                    <Typography variant={"h6"}>Shared Slides</Typography>
                    <List>
                        {notNull(this.state.sharedEntitites) && this.state.sharedEntitites.map((entity) => {
                            return (<ListItem><ListItemText>{entity}</ListItemText></ListItem>)
                        })
                        }
                    </List>
                </div>
            )
        }
    }

    setColumns = () => {
        this.columns = [
            {field: 'id', headerName: 'ID', flex: 0.25, valueGetter: (params) => params.row.id},
            {
                field: 'copy',
                headerName: 'Copy Link',
                flex: 0.25,
                renderCell: this.renderCopyUrlButton,
                disableClickEventBubbling: true,
            },
            {
                field: 'expiry',
                headerName: 'Validity',
                flex: 0.5,
                valueGetter: (params) => isNull(params.row.expiry) ? 'Life-time' : new Date(params.row.expiry).toLocaleString(),
                type: 'dateTime'
            },
            {field: 'created_by', headerName: 'Created By', flex: 0.5, sortable: false},
            {
                field: 'revoke_access',
                headerName: '',
                flex: 1,
                sortable: false,
                renderCell: this.renderRevokeAccessButton,
                disableClickEventBubbling: true,
            },
        ];
    }

    render() {

        if (isNull(this.state.rows)) {
            return (
                <div className={'full-parent flex-center'}>
                    <CircularProgress/>
                </div>
            )
        }

        return (
            <div className={"full-parent"}>
                {this.getConfirmRevokeDialogComponent()}
                <Grid container className={"full-parent"}>
                    <Grid item xs={8}>
                        <DataGrid
                            rows={this.state.rows}
                            columns={this.columns}
                            onSelectionModelChange={(ids) => {
                                this.setState({selectedRow: ids[0]})
                            }}
                            autoPageSize
                        />
                    </Grid>
                    <Grid item xs={4}>
                        {this.getUrlDetails()}

                    </Grid>

                </Grid>

            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(SharedUrlsView);
